import api from '../api'

export default {
	getOpenProvince (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    	api.get('api/front/v2/baseinfo/city', data, successCallback, errCallback, isShowErrMsg)
  	},
  	getOriginProvince (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    	api.get('api/front/v2/baseinfo/region', data, successCallback, errCallback, isShowErrMsg)
  	},

}


// WEBPACK FOOTER //
// ./src/api/address/api.address.js